import styles from '../Table.module.scss';
import { PaginationSelectBoxItem } from '@/types/table/tableOptions';

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_MIN_COLUMN_SIZE = 88;
export const DEFAULT_MAX_COLUMN_SIZE = 632;
export const DEFAULT_TABLE_WIDTH = 1380;
export const ROW_HEIGHT_IN_REM = 4.8;
export const ROW_EXPANSION_ANIMATION_DURATION = 200;
export const MIN_COLUMNS_FOR_ADJUST_TABLE = 4;

export const transitionClasses = {
  enter: styles.enter,
  enterFrom: styles.collapsed,
  enterTo: styles.expanded,
  leave: styles.enter,
  leaveFrom: styles.expanded,
  leaveTo: styles.collapsed,
};

export const defaultSelectBoxOptions: PaginationSelectBoxItem[] = [
  { label: '5', value: 5 },
  { label: '10', value: 10 },
];
